export const buildUnifiedDisposalBoard = (mixes = [], cycleRepaymentTable = []) => {
  const firstMix = [mixes[0]];
  return firstMix.map((mix) => {
    const mergedBoard = [];
    let totalInterestReturn = 0;
    let totalReturn = 0;
    let totalAdditionalFee = 0;
    let maxMonthlyReturn = 0;
    let minMonthlyReturn = Infinity;

    const mixBoard = mix?.disposalBoard || [];
    const maxLoanPeriodLength = Math.max(
      mixBoard.length,
      cycleRepaymentTable.length,
    );

    for (let i = 0; i < maxLoanPeriodLength; i += 1) {
      const cycle = cycleRepaymentTable[i] || {};
      const currentMixMonth = mixBoard[i] || {};

      const monthlyInterestReturn = (cycle?.total?.interest || 0)
                + (currentMixMonth?.monthlyInterestReturn || 0);

      const monthlyFundReturn = (cycle?.total?.principal || 0)
                + (currentMixMonth?.monthlyFundReturn || 0);

      const totalMonthlyReturn = (cycle?.total?.totalPayment || 0)
                + (currentMixMonth?.totalMonthlyReturn || 0);

      const additionalFee = (cycle?.total?.linkage || 0)
                + (currentMixMonth?.additionalAmountDueToAdditionalFee || 0);

      const fundBalance = (currentMixMonth?.fundBalance || 0)
                + (cycle?.total?.remainingPrincipal || 0);

      totalInterestReturn += monthlyInterestReturn;
      totalReturn += totalMonthlyReturn;
      totalAdditionalFee += additionalFee;

      maxMonthlyReturn = Math.max(maxMonthlyReturn, totalMonthlyReturn);
      minMonthlyReturn = Math.min(minMonthlyReturn, totalMonthlyReturn);

      mergedBoard.push({
        period: i + 1,
        totalMonthlyReturn,
        monthlyInterestReturn,
        monthlyFundReturn,
        additionalAmountDueToAdditionalFee: additionalFee,
        fundBalance,
      });
    }

    const returnConversion = totalInterestReturn ? totalReturn / totalInterestReturn : 0;

    return {
      ...mix,
      disposalBoard: mergedBoard,
      maxMonthlyReturn,
      minMonthlyReturn: minMonthlyReturn === Infinity ? 0 : minMonthlyReturn,
      returnConversion,
      totalAdditionalAmountDueToAdditionalFee: totalAdditionalFee,
      totalInterestReturn,
      totalReturn,
    };
  });
};
